import { render, staticRenderFns } from "./WebsiteResetPwdComponent.vue?vue&type=template&id=38fda004&scoped=true"
import script from "./WebsiteResetPwdComponent.vue?vue&type=script&lang=js"
export * from "./WebsiteResetPwdComponent.vue?vue&type=script&lang=js"
import style0 from "./WebsiteResetPwdComponent.vue?vue&type=style&index=0&id=38fda004&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fda004",
  null
  
)

export default component.exports